module.exports = __webpack_public_path__ + "img/logo_dark.93e2ada9.png";